import { render, staticRenderFns } from "./registerCard.vue?vue&type=template&id=6da62194&scoped=true"
import script from "./registerCard.vue?vue&type=script&lang=js"
export * from "./registerCard.vue?vue&type=script&lang=js"
import style0 from "./registerCard.vue?vue&type=style&index=0&id=6da62194&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da62194",
  null
  
)

export default component.exports